module.exports = __webpack_public_path__ + "static/android-chrome-512x512-fc49ba535d682305d23d1e7e6fbdda33.png";